import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromStendere } from "@/components/calculators/lineMappers";
import { stendereCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/stendere")({
  component: StenderePage,
});

function StenderePage() {
  const [lengde, setLengde] = useState<number | "">("");
  const [hoyde, setHoyde] = useState<number | "">(2.4);
  const [cc, setCc] = useState<number | "">(600);
  const [apn, setApn] = useState<number | "">(0);

  const r = useMemo(() => {
    if (lengde === "" || hoyde === "" || cc === "") return null;
    return stendereCalc({
      vegg_lengde_m: Number(lengde),
      vegg_hoyde_m: Number(hoyde),
      cc_mm: Number(cc),
      antall_apninger: apn === "" ? undefined : Number(apn),
    });
  }, [lengde, hoyde, cc, apn]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Bindingsverk / stendere" subtitle="Beregn stendere og svill for vegg." />
      <CalcShell
        title="Inndata"
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Antall stendere", value: `${fmt(r.stendere, 0)} stk`, strong: true },
              { label: "Løpemeter stender", value: `${fmt(r.stender_lm, 1)} m` },
              { label: "Løpemeter svill (topp + bunn)", value: `${fmt(r.svill_lm, 1)} m` },
              { label: "Total løpemeter", value: `${fmt(r.total_lm, 1)} m` },
            ]}
            note="Hver åpning legger til 3 ekstra stendere (bæringsstender + doble på hver side)."
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Bindingsverk`} lines={linesFromStendere(r)} defaultLaborHours={Math.max(0, Math.round((r.stendere * 0.25) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn vegglengde, høyde og c/c.</div>}
      >
        <Field label="Vegglengde" unit="m"><NumberInput value={lengde} onChange={setLengde} /></Field>
        <Field label="Vegghøyde" unit="m"><NumberInput value={hoyde} onChange={setHoyde} /></Field>
        <Field label="c/c stender" unit="mm"><NumberInput value={cc} onChange={setCc} /></Field>
        <Field label="Antall åpninger (vindu/dør)"><NumberInput value={apn} onChange={setApn} /></Field>
      </CalcShell>
    </>
  );
}
